import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

const OverviewChart = ({Statistics}) => {
  const data = {
    labels: ["Active prescriptions", "Unactive prescriptions "],
    datasets: [
      {
        label: "Overview",
        data: [Statistics.ValidPrescribedMedicines, Statistics.ExpiredPrescribedMedicines],
        backgroundColor: ["#3371EB", "#C0D3F9"],
        hoverOffset: 4,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          usePointStyle: true, // Makes the legend labels display as circle-like points
          pointStyle: "circle", // Sets the legend item as a circle
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return tooltipItem.raw + " items";
          },
        },
      },
    },
    cutout: "70%",
  };

  return (
    <div>
      <div className="top flex justify-between mb-5 items-center">
        <h2 className="text-[20px] text-[#45464Es] font-semibold">Overview</h2>
        <div className="filter text-[#BEC0CA]">
          {/* <select name="period" id="period" className="cursor-pointer">
            <option value="this-month" className="text-[black]">
              This Month
            </option>
            <option value="this-week" className="text-[black]">
              This Week
            </option>
            <option value="this-day" className="text-[black]">
              This Day
            </option>
          </select> */}
        </div>
      </div>
      <div className="mx-auto w-fit">
        <Doughnut data={data} options={options} />
      </div>
    </div>
  );
};

export default OverviewChart;
